import type { Field } from '@/views/Coversheet/configurations/types';

export enum AutofillProvider {
  googlePlacesSearch = 'googlePlacesSearch',
  contactSuggestion = 'contactSuggestion',
  googleContacts = 'googleContacts',
}

export enum AutofillConstraint {
  limitToLicensedStates = 'limitToLicensedStates',
  limitToInteractionState = 'limitToInteractionState',
}

export const doesFieldHaveConstraint = (
  provider: AutofillProvider,
  constraint: AutofillConstraint,
  field?: Field,
) =>
  !!(
    field?.action?.provider === provider &&
    field?.action?.constraints?.includes(constraint)
  );
